import React, { createContext } from 'react';
import { bool, func, node, string } from 'prop-types';
import { useFela } from 'react-fela';
import { Block } from '../block';
import { Message } from '../message';
import { View } from '../view';

const labelStyle = _ref => {
  let {
    isValid,
    theme
  } = _ref;
  return {
    color: isValid ? theme.color.foreground.secondary : theme.color.foreground.alert,
    fontSize: 16,
    letterSpacing: '0.02em',
    fontFamily: theme.fontTypes.NOVUM,
    fontWeight: 300
  };
};

export const RadioContext = /*#__PURE__*/createContext({});
export function RadioGroup(_ref2) {
  let {
    legend,
    name,
    isValid = true,
    value,
    onChange,
    errorMessage,
    description,
    children
  } = _ref2;
  const {
    theme
  } = useFela();
  const styleProps = {
    isValid,
    theme
  };
  const context = {
    name,
    isValid,
    value,
    onChange
  };
  const messages = /*#__PURE__*/React.createElement(React.Fragment, null, !errorMessage ? null : /*#__PURE__*/React.createElement(Message, {
    type: "error"
  }, errorMessage), !description ? null : /*#__PURE__*/React.createElement(Message, null, description));
  return /*#__PURE__*/React.createElement(View, {
    spacing: 0.5
  }, /*#__PURE__*/React.createElement(Block, {
    as: "legend",
    extend: labelStyle(styleProps)
  }, legend), /*#__PURE__*/React.createElement(RadioContext.Provider, {
    value: context
  }, children), messages);
}
RadioGroup.propTypes = {
  name: string,

  /** Renders a legend.  */
  legend: string,

  /** Renders a description text underneath the input.  */
  description: string,

  /** Renders a red error message for validation underneath the input.  */
  errorMessage: string,

  /** onChange handler. Triggers on every keyboard and generally
   * is here where you change the value of the `value` property  */
  onChange: func.isRequired,

  /** Value of the textInput. This should be stored in the
   * state of the parent component  */
  value: string.isRequired,

  /** Renders the input as valid or invalid */
  isValid: bool,

  /** A JSX node */
  children: node
};